import "./Loader.scss";

const Loader = () => {
  return (
    <div className="spinner">
      <div className="bubble-1"></div>
      <div className="bubble-2"></div>
    </div>
  );
};

export default Loader;
